export const capitalizeFirstLetter = (text: string) =>
    text[0].toUpperCase() + text.slice(1);

export const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
        return text;
    }
    return text.slice(0, maxLength).trim() + '...';
};
